<template>
  <div
    class="logoComponent hidden-md-and-down"
    :class="{ 'shared-cart-mode': cartStore.isSharedCartMode }"
  >
    <SBtn
      :disabled="!clickable"
      height="67px"
      text
      @click="redirectHome()"
    >
      <SBlankablePicture :media="HEADER_LOGO_BLANK_MEDIA">
        <img
          :src="logoSrc"
          :alt="$t('header.logo.alt')"
          height="67px"
          width="114px"
        >
      </SBlankablePicture>
    </SBtn>
  </div>
</template>

<script lang="ts" setup>
import { useCartStore } from '~/stores/cart'
import { HEADER_LOGO_BLANK_MEDIA } from '~/utils/format/imageSizes'
import { mediaAssetUrl } from '~/utils/format/mediaAssets'

interface Props {
 clickable?: boolean
}

withDefaults(defineProps<Props>(), {
  clickable: true
})

const { redirectHome } = useRedirect()
const cartStore = useCartStore()

// `SU_Logo`, not `su_logo` — the stored key is mixed case and the media host,
// unlike Cloudinary delivery, is case-sensitive (ADO 62986).
const logoSrc = computed(() => mediaAssetUrl('application_assets/SU_Logo.png'))
</script>

<style lang='scss' scoped>

</style>
